import { render, staticRenderFns } from "./ques-pro.vue?vue&type=template&id=7bfad82b&scoped=true&"
import script from "./ques-pro.vue?vue&type=script&lang=js&"
export * from "./ques-pro.vue?vue&type=script&lang=js&"
import style0 from "./ques-pro.vue?vue&type=style&index=0&id=7bfad82b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfad82b",
  null
  
)

export default component.exports